import { useEffect } from 'react';
import { ApiService } from '../api/ApiService';

export function logPageVisit(subtype: string, message: string) {
    ApiService.sendEventCommand(subtype, 'eventCheck', message);
}

/** Fires on mount. LP routes use React Switch, so Ionic view-enter does not run. */
export function useLogPageVisit(subtype: string, message: string) {
    useEffect(() => {
        logPageVisit(subtype, message);
    }, [subtype, message]);
}
